import { jsx as _jsx } from "react/jsx-runtime";
import { CircularProgress } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import classNames from "classnames";
const useStyles = makeStyles((theme) => createStyles({
    root: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
    },
    progress: {
        margin: theme.spacing(2),
    },
}));
const circularProgressPropsBySize = {
    xs: {
        size: 20,
        thickness: 5,
    },
    sm: {
        size: 50,
    },
    md: {
        size: 75,
    },
    lg: {
        size: 100,
    },
};
export const Loading = ({ classes, progressSize }) => {
    const baseClasses = useStyles();
    const DEFAULT_SIZE = "md";
    return (_jsx("div", { className: classNames(baseClasses.root, classes?.root), children: _jsx(CircularProgress, { className: classes?.spinner, ...circularProgressPropsBySize[progressSize || DEFAULT_SIZE] }) }));
};
//# sourceMappingURL=Loading.js.map